import React, {useState, useEffect} from 'react'

export default function TypeSteps(props) {

    const [type, setType] = useState('')
    const [dueDates, setDueDates] = useState({})

    function getStepsByType(currentType) {
        if (!currentType) return []
        switch (currentType) {
            case 'RD':
                return ['Reunião 1:1']
            case 'BD':
                return ['Avaliação do Gestor', 'Reunião 1:1']
            case 'AD':
                return ['Auto Avaliação', 'Avaliação do Gestor', 'Reunião 1:1']
            case 'SD':
                return ['Auto Avaliação', 'Avaliar Superior', 'Avaliação do Gestor', 'Reunião 1:1']
            case 'TD':
                return ['Auto Avaliação', 'Avaliar Superior', 'Avaliação do Gestor', 'Avaliação de Pares', 'Reunião 1:1']
            default:
                return []
        }
    }

    const TITLE_TO_CODE = {
        'Reunião 1:1': 'RN',
        'Auto Avaliação': 'AA',
        'Avaliar Superior': 'AS',
        'Avaliação do Gestor': 'AG',
        'Avaliação de Pares': 'AP'
    }

    function emitStepsChange(steps, map) {
        if (!steps || steps.length === 0) return
        const payload = steps.map((stp) => ({
            code: TITLE_TO_CODE[stp] || '',
            date: map[stp] || ''
        }))
        if (props.onChangeSteps) props.onChangeSteps(payload)
    }

    function handleDateChange(stepTitle, value) {
        setDueDates((prev) => {
            const next = { ...prev, [stepTitle]: value }
            if (props.onChange) {
                props.onChange(next)
            }
            emitStepsChange(getStepsByType(type), next)
            return next
        })
    }

    function parseDateString(value) {
        if (!value) return null
        // Accepts 'YYYY-MM-DD'
        const [y, m, d] = value.split('-').map((v) => parseInt(v, 10))
        if (!y || !m || !d) return null
        return new Date(y, m - 1, d)
    }

    function formatDateYYYYMMDD(dateObj) {
        if (!dateObj || isNaN(dateObj.getTime())) return ''
        const y = dateObj.getFullYear()
        const m = String(dateObj.getMonth() + 1).padStart(2, '0')
        const d = String(dateObj.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
    }

    function clampToMax(dateStr, maxStr) {
        if (!maxStr) return dateStr
        const date = parseDateString(dateStr)
        const max = parseDateString(maxStr)
        if (!date || !max) return dateStr
        if (date > max) return formatDateYYYYMMDD(max)
        return dateStr
    }

    function prefillDueDates(currentType) {
        const steps = getStepsByType(currentType)
        if (steps.length === 0) return {}

        const startDateStr = props.startDate || props.start_date || ''
        const endDateStr = props.endDate || props.end_date || ''

        const endDate = parseDateString(endDateStr)
        const startDate = parseDateString(startDateStr)

        // If no end date provided, do not prefill
        if (!endDate) return {}

        // Use one day before end date for the last step when possible
        const endDateMinus = new Date(endDate.getTime())
        endDateMinus.setDate(endDateMinus.getDate() - 1)
        // If subtracting a day makes it invalid (before start), fallback to endDate itself
        const lastStepMaxDate = startDate && endDateMinus < startDate ? endDate : endDateMinus

        // If we already have initial due dates, use them but clamp to endDate
        const initialMap = props.initialDueDates || {}
        const hasInitial = initialMap && Object.keys(initialMap).length > 0
        if (hasInitial) {
            const next = {}
            steps.forEach((stp) => {
                const val = initialMap[stp] || ''
                // clamp all steps to at most lastStepMaxDate
                const clamped = clampToMax(val, formatDateYYYYMMDD(lastStepMaxDate))
                next[stp] = clamped
            })
            return next
        }

        // No initial map. If start date present and before end date, distribute evenly.
        if (startDate && startDate <= endDate) {
            const totalMs = endDate.getTime() - startDate.getTime()
            const n = steps.length
            const next = {}
            steps.forEach((stp, idx) => {
                // Even distribution across the window; last step equals endDate
                if (idx === n - 1) {
                    // Last step should be slightly earlier than end date
                    next[stp] = formatDateYYYYMMDD(lastStepMaxDate)
                } else {
                    const ratio = (idx + 1) / n
                    const ms = startDate.getTime() + Math.round(totalMs * ratio)
                    const dt = new Date(ms)
                    // Clamp just in case rounding overshoots (to one day before end)
                    next[stp] = clampToMax(formatDateYYYYMMDD(dt), formatDateYYYYMMDD(lastStepMaxDate))
                }
            })
            return next
        }

        // Fallback: set every step to end date
        const next = {}
        steps.forEach((stp, idx) => {
            // Ensure the last step is a little before the end date
            const valueDate = idx === steps.length - 1 ? lastStepMaxDate : endDateMinus
            next[stp] = formatDateYYYYMMDD(valueDate)
        })
        return next
    }

    // Recompute prefilled dates when type or relevant props change
    useEffect(() => {
        if (!type) return
        const pre = prefillDueDates(type)
        if (Object.keys(pre).length > 0) {
            setDueDates(pre)
            if (props.onChange) props.onChange(pre)
            emitStepsChange(getStepsByType(type), pre)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, props.startDate, props.start_date, props.endDate, props.end_date])

    useEffect(() => {

        if(props.type) {
            setType(props.type)
        }

    }, [props])

    const steps = getStepsByType(type)

    return (
        <div>
            {
                type && type !== 'PD' ?
                <>
                    <p className='fw-bold mb-1'>Configure prazos para cada etapa <span className="text-danger">*</span></p>
                    <div className='border rounded overflow-hidden'>
                    <table className='table mb-0'>
                        <thead className='border-bottom'>
                            <tr>
                                <th style={{width: '60%'}}>Etapa</th>
                                <th style={{width: '40%'}}>Prazo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                steps.map((stp) => (
                                    <tr key={stp}>
                                        <td className='align-middle'>{stp}</td>
                                        <td>
                                            <input
                                                className='form-control form-control-sm'
                                                type='date'
                                                value={dueDates[stp] || ''}
                                                min={(props.startDate || props.start_date) || ''}
                                                max={(props.endDate || props.end_date) || ''}
                                                onChange={(e) => handleDateChange(stp, e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    </div>
                </>
                : null
            }
        </div>
    )

}